/**
 * @generated SignedSource<<47fef5561d89eb7eaa08d1f59cf5e211>>
 * @relayHash e90d0de6a1887a574ac2a5cb1682cfe9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e5c60bb2ef5a0a6200fbf9e40745797dd43ce5e1ed46b26290f07d138c87af1b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluencePricingEndOfTrialPremiumToStandardQuery$variables = {
  cloudId: string;
  productKey: string;
};
export type ConfluencePricingEndOfTrialPremiumToStandardQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities?: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly standardPrice?: ReadonlyArray<{
          readonly listPriceForOrderWithDefaults: ReadonlyArray<{
            readonly averageAmountPerUnit: number | null | undefined;
            readonly item: {
              readonly chargeElement: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly trial: {
            readonly listPriceEstimates: ReadonlyArray<{
              readonly averageAmountPerUnit: number | null | undefined;
              readonly item: {
                readonly chargeElement: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount?: {
          readonly isBillToPresent: boolean | null | undefined;
          readonly isCurrentUserBillingAdmin: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type ConfluencePricingEndOfTrialPremiumToStandardQuery = {
  response: ConfluencePricingEndOfTrialPremiumToStandardQuery$data;
  variables: ConfluencePricingEndOfTrialPremiumToStandardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "isBillToPresent"
},
v4 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v5 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "offeringName",
          "value": "standard"
        },
        {
          "kind": "Literal",
          "name": "skipTrial",
          "value": true
        }
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAvailableToUser"
        },
        {
          "kind": "ScalarField",
          "name": "experienceUrl"
        }
      ],
      "storageKey": "changeOfferingV2(offeringName:\"standard\",skipTrial:true)"
    }
  ]
},
v6 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Standard"
  }
],
v7 = [
  {
    "kind": "ScalarField",
    "name": "averageAmountPerUnit"
  },
  {
    "concreteType": "CcpPricingPlanItem",
    "kind": "LinkedField",
    "name": "item",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "chargeElement"
      }
    ]
  }
],
v8 = {
  "concreteType": "CcpListPriceEstimate",
  "kind": "LinkedField",
  "name": "listPriceForOrderWithDefaults",
  "plural": true,
  "selections": (v7/*: any*/)
},
v9 = {
  "concreteType": "CcpTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpListPriceEstimate",
      "kind": "LinkedField",
      "name": "listPriceEstimates",
      "plural": true,
      "selections": (v7/*: any*/)
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      (v5/*: any*/),
                      {
                        "alias": "standardPrice",
                        "args": (v6/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                      },
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ]
                      }
                    ],
                    "type": "CcpEntitlement"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v11/*: any*/)
                        ]
                      },
                      (v5/*: any*/),
                      {
                        "alias": "standardPrice",
                        "args": (v6/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                      },
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v11/*: any*/)
                        ]
                      }
                    ],
                    "type": "CcpEntitlement"
                  },
                  (v11/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e90d0de6a1887a574ac2a5cb1682cfe9",
    "id": "e5c60bb2ef5a0a6200fbf9e40745797dd43ce5e1ed46b26290f07d138c87af1b",
    "metadata": {},
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "operationKind": "query",
    "text": "query ConfluencePricingEndOfTrialPremiumToStandardQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,...on CcpEntitlement{transactionAccount{isBillToPresent,isCurrentUserBillingAdmin,id},experienceCapabilities{changeOfferingV2(skipTrial:true,offeringName:\"standard\"){isAvailableToUser,experienceUrl}},standardPrice:defaultOfferingTransitions(offeringName:\"Standard\"){listPriceForOrderWithDefaults{averageAmountPerUnit,item{chargeElement}},id},subscription{trial{listPriceEstimates{averageAmountPerUnit,item{chargeElement}}},id}},id}}}}"
  }
};
})();

(node as any).hash = "72ad732176200cb16add113a636c4dc2";

export default node;
